import { PermissionStatus } from '@capacitor/geolocation';
import { create } from 'zustand';

import { ILocationDecoded } from '@mopla/data-models';
import { LatLng } from '@mopla/utils';

export interface IGeoPositionState {
	/** Current coordinates */
	coordinates: LatLng | null;
	/** Decoded address from coordinates */
	address: ILocationDecoded | null;
	/** Current permission status */
	permissionStatus: PermissionStatus | null;
	/** Loading state for fetching position */
	isLoadingPosition: boolean;
	/** Loading state for geocoding */
	isGeocoding: boolean;
	/** ID of the active watchPosition, or null if not watching */
	watchingPositionId: string | null;
	/** Error message if any */
	error: string | null;

	/** Simple setters for state updates */
	setCoordinates: (coords: LatLng | null) => void;
	setAddress: (address: ILocationDecoded | null) => void;
	setPermissionStatus: (status: PermissionStatus | null) => void;
	setIsLoadingPosition: (loading: boolean) => void;
	setIsGeocoding: (loading: boolean) => void;
	setWatchingPositionId: (id: string | null) => void;
	setError: (error: string | null) => void;
}

const initialState = {
	coordinates: null,
	address: null,
	permissionStatus: null,
	isLoadingPosition: false,
	isGeocoding: false,
	watchingPositionId: null,
	error: null,
};

export const useGeoPositionStore = create<IGeoPositionState>((set) => ({
	...initialState,

	setCoordinates: (coordinates) => set({ coordinates }),
	setAddress: (address) => set({ address }),
	setPermissionStatus: (permissionStatus) => set({ permissionStatus }),
	setIsLoadingPosition: (isLoadingPosition) => set({ isLoadingPosition }),
	setIsGeocoding: (isGeocoding) => set({ isGeocoding }),
	setWatchingPositionId: (watchingPositionId) => set({ watchingPositionId }),
	setError: (error) => set({ error }),
}));
